import React from 'react';
import { DjayIllustrationProps } from '../types';
import { DjayIllustrationBase } from '../DjayIllustrationBase';
import { DjaySpecimen } from '../../DjaySpecimen';
export function ConsistentIllustration({
  achievementId,
  variant = 'default',
  isUnlocked,
  rarity,
  size = 'md',
  animate = true,
  className = ''
}: DjayIllustrationProps) {
  return <DjayIllustrationBase isUnlocked={isUnlocked} rarity={rarity} size={size} className={className} data-id="element-3844" data-mp="1yiurz6st2s67">
      
      <div className="relative w-full h-full bg-gradient-to-br from-blue-50 to-indigo-100 overflow-hidden" data-id="element-3845" data-mp="2m8p3nl1e2aov">
        {/* Background: Giant Calendar */}
        <svg className="absolute inset-0 w-full h-full z-0" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3846" data-mp="2cfi2kcdolgul">
          
          <g transform="translate(40, 20) scale(1.2)" data-id="element-3847" data-mp="2hd9qkvb7giti">
            {/* Calendar Board */}
            <rect x="0" y="10" width="100" height="100" rx="8" fill="#FFFFFF" stroke="#CBD5E1" strokeWidth="2" data-id="element-3848" data-mp="35341h7byrxb4" />
            
            <rect x="0" y="10" width="100" height="25" rx="8" fill="#EF4444" data-id="element-3849" data-mp="dhc2xd8eykrs" />
            <rect x="0" y="25" width="100" height="10" fill="#EF4444" data-id="element-3850" data-mp="df7v4k7e91m8" />

            {/* Rings */}
            <rect x="20" y="0" width="6" height="20" rx="3" fill="#94A3B8" data-id="element-3851" data-mp="8g4vjfa6nnln" />
            <rect x="74" y="0" width="6" height="20" rx="3" fill="#94A3B8" data-id="element-3852" data-mp="mb75cdi5hx3q" />

            {/* Grid */}
            <path d="M0 55 L100 55 M0 75 L100 75 M0 95 L100 95" stroke="#E2E8F0" strokeWidth="1" data-id="element-3853" data-mp="hhmh3d6d0hhq" />
            
            <path d="M25 35 L25 110 M50 35 L50 110 M75 35 L75 110" stroke="#E2E8F0" strokeWidth="1" data-id="element-3854" data-mp="w9wosapp3pm3" />
            

            {/* Checkmarks */}
            {isUnlocked && <g stroke="#22C55E" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" fill="none" data-id="element-3855" data-mp="157gtjtmro41g">
              
                <path d="M5 45 L10 50 L20 40" data-id="element-3856" data-mp="117ogb3mfh9pr" />
                <path d="M30 45 L35 50 L45 40" data-id="element-3857" data-mp="36zbouyoptvxi" />
                <path d="M55 45 L60 50 L70 40" data-id="element-3858" data-mp="37050acymd9lz" />
                <path d="M80 45 L85 50 L95 40" data-id="element-3859" data-mp="32yrt9zjsj0dh" />

                <path d="M5 65 L10 70 L20 60" data-id="element-3860" data-mp="3302x1zd8k84l" />
                <path d="M30 65 L35 70 L45 60" data-id="element-3861" data-mp="15y5h35vkdufp" />
                <path d="M55 65 L60 70 L70 60" data-id="element-3862" data-mp="15zgjp2d9ww58" />
                <path d="M80 65 L85 70 L95 60" data-id="element-3863" data-mp="1aw6ylmdcdlp2" />
              </g>}
          </g>
        </svg>

        {/* Djay */}
        <div className="absolute inset-0 z-10 flex items-end justify-center pb-[5%]" data-id="element-3864" data-mp="1fvjv6yu0m74u">
          <div className="w-[65%] h-[65%] flex items-center justify-center" data-id="element-3865" data-mp="1kvfpu7gtom7q">
            <DjaySpecimen look={{
            variant,
            accessory: 'trophy'
          }} size="hero" emotion={isUnlocked ? 'excited' : 'thinking'} animate={animate && isUnlocked} className="w-full h-full" data-id="element-3866" data-mp="1owhrsw24jcde" />
            
          </div>
        </div>

        {/* Foreground: Desk/Floor */}
        <svg className="absolute bottom-0 left-0 w-full h-1/5 z-20 pointer-events-none" viewBox="0 0 200 40" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" data-id="element-3867" data-mp="23le81gec3vp3">
          
          <path d="M0 20 L200 20 L200 40 L0 40 Z" fill="#94A3B8" opacity="0.2" data-id="element-3868" data-mp="28inx2uxta5ce" />
          
        </svg>
      </div>
    </DjayIllustrationBase>;
}